export default __webpack_public_path__ + "static/media/analytics_icon.b06b2f5d.svg";